// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AssetCreationUpload } from '@/asset/components/asset-creation-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function AssetCreationImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Import new assets</DialogTitle>
      <DialogContent dividers>
        <AssetCreationUpload onClose={props.onClose} />
      </DialogContent>
    </Dialog>
  );
}
